/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductClassificationChildrenQueryVariables = Exact<{
  parentCode: string;
}>;


export type ProductClassificationChildrenQuery = { product_classification_node: Array<{ code: string }> };


export const ProductClassificationChildrenDocument = /*#__PURE__*/ gql`
    query ProductClassificationChildren($parentCode: String!) {
  product_classification_node(where: {parent_code: {_eq: $parentCode}}) {
    code
  }
}
    `;

/**
 * __useProductClassificationChildrenQuery__
 *
 * To run a query within a React component, call `useProductClassificationChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClassificationChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClassificationChildrenQuery({
 *   variables: {
 *      parentCode: // value for 'parentCode'
 *   },
 * });
 */
export function useProductClassificationChildrenQuery(baseOptions: Apollo.QueryHookOptions<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables> & ({ variables: ProductClassificationChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>(ProductClassificationChildrenDocument, options);
      }
export function useProductClassificationChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>(ProductClassificationChildrenDocument, options);
        }
// @ts-ignore
export function useProductClassificationChildrenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>;
export function useProductClassificationChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationChildrenQuery | undefined, ProductClassificationChildrenQueryVariables>;
export function useProductClassificationChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>(ProductClassificationChildrenDocument, options);
        }
export type ProductClassificationChildrenQueryHookResult = ReturnType<typeof useProductClassificationChildrenQuery>;
export type ProductClassificationChildrenLazyQueryHookResult = ReturnType<typeof useProductClassificationChildrenLazyQuery>;
export type ProductClassificationChildrenSuspenseQueryHookResult = ReturnType<typeof useProductClassificationChildrenSuspenseQuery>;
export type ProductClassificationChildrenQueryResult = Apollo.QueryResult<ProductClassificationChildrenQuery, ProductClassificationChildrenQueryVariables>;